/**
 * Converts milliseconds to hours and minutes
 * @param {number} milliseconds - The duration in milliseconds
 * @returns {object} An object containing hours and minutes
 */
export function convertMillisecondsToHoursAndMinutes(milliseconds) {
  // Constants for conversion
  const millisecondsInHour = 3600000; // 60 * 60 * 1000
  const millisecondsInMinute = 60000; // 60 * 1000

  // Calculate hours (integer division)
  const hours = Math.floor(milliseconds / millisecondsInHour);

  // Calculate remaining milliseconds after extracting hours
  const remainingMilliseconds = milliseconds % millisecondsInHour;

  // Calculate minutes from the remaining milliseconds
  const minutes = Math.floor(remainingMilliseconds / millisecondsInMinute);

  if (!hours && !minutes) {
    return undefined;
  }

  return `${hours}:${String(minutes).padStart(2, '0')}`;
}
